import React from "react";
import PropTypes from "prop-types";
import { RefluxComponent } from "sp-react-commons";
import { UserActions } from "../../../commons";
import { UserApi } from "./../../api/Api";
import UserPostList from "./UserPostList";
import { UserStore } from "../../../commons";
import Translation from "../../../commons/i18n/Translation";
import { UserAvatarPresenter } from '../../../commons';
import AppConfig from 'AppConfig';

import Svg from "../../../../svg/Svg";

import mywortLogoNegative from "../../../../../images/mywort/mywort-logo--negative.png";
import userModule1 from "../../../../../images/usermodule/01.gif";
import userModule1x2 from "../../../../../images/usermodule/01@2x.gif";
import userModule2 from "../../../../../images/usermodule/02.gif";
import userModule2x2 from "../../../../../images/usermodule/02@2x.gif";
import userModule3 from "../../../../../images/usermodule/03.gif";
import userModule3x2 from "../../../../../images/usermodule/03@2x.gif";
import loaderMedium from "../../../../../images/loader-medium.gif";


class MyWortRegister extends React.Component {

    render = () => (
        <div className="user-module__main">
            <div className="user-module__no-access">
                <div className="user-module__no-access__name">{Translation.translate("user-module.hi")} {this.props.user.firstName},</div>
                <div className="user-module__no-access__sub">{Translation.translate("user-module.expect")}</div>
                <div className="user-module__no-access__text">{Translation.translate("user-module.take-a-look")}</div>
                <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/post/create"} className="mywort-btn mywort-btn--orange mywort-btn--large user-module__no-access-btn">{Translation.translate("user-module.create-first")}</a>
                <div className="user-module__no-access__footer">{Translation.translate("user-module.create-text-footer")}</div>
            </div>
        </div>
    )
}

class MyWortBlocked extends React.Component {

    render = () => (
        <div className="user-module__main">
            <div className="user-module__no-access">
                <div className="user-module__no-access__name">{Translation.translate("user-module.you-are-blocked")}</div>

                <div className="user-module__no-access__text">{Translation.translate("user-module.contact-admin")}</div>
                <div className="user-module__no-access__email"><a href={"mailto:" + Translation.translate("user-module.contact-email")}>{Translation.translate("user-module.contact-email")}</a> </div>
            </div>
        </div>
    )
}

class LoginAndRegister extends React.Component {

    componentDidMount() {
        $("#owl-user-module").owlCarousel({
            items: 1,
            slideBy: 1,
            smartSpeed: 400,
            dotsSpeed: 300,
            autoHeight: true, // Not documented in Owl carousel docs, but seems to fix wrong calculated height issue
            autoplay: true,
            autoplayTimeout: 7000,
            rewind: true,
            center: true
        });
    }

    render = () => (
        <div className="user-module-container">
            <div className="user-module__subtitle">
               <img src={mywortLogoNegative}/>
            </div>
            <div className="user-module__switcher">
              <div id="owl-user-module" className="owl-carousel">
                <div className="switcher-content">
                  <div className="switcher-content__icon">
                    <img src={userModule1} srcSet={`${userModule1} 1x, ${userModule1x2} 2x`} />
                  </div>
                  <div className="switcher-text">
                    <div className="switcher-text__title">{Translation.translate("user-module.carousel-title-1")}</div>
                    <div className="switcher-text__desc">
                    {Translation.translate("user-module.carousel-sub-1")}</div>
                  </div>
                </div>
                <div className="switcher-content">
                  <div className="switcher-content__icon">
                    <img src={userModule2} srcSet={`${userModule2} 1x, ${userModule2x2} 2x`} />
                  </div>
                  <div className="switcher-text">
                    <div className="switcher-text__title">{Translation.translate("user-module.carousel-title-2")}</div>
                    <div className="switcher-text__desc">{Translation.translate("user-module.carousel-sub-2")}
                        <div>{Translation.translate("user-module.carousel-sub-2-1")}</div>
                    </div>
                  </div>
                </div>
                <div className="switcher-content">
                  <div className="switcher-content__icon">
                    <img src={userModule3} srcSet={`${userModule3} 1x, ${userModule3x2} 2x`} />
                  </div>
                  <div className="switcher-text">
                    <div className="switcher-text__title">{Translation.translate("user-module.carousel-title-3")}</div>
                    <div className="switcher-text__desc">{Translation.translate("user-module.carousel-sub-3")}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="user-module-container__btn">
              <a href={AppConfig.mywortWebHost +"/oauth/login?lang=" + Translation.getLanguageName() + "&referrer=/" + Translation.getLanguageName() + "/mywort/edit#/post/create"} className="mywort-btn mywort-btn--large mywort-btn--invert-orange">{Translation.translate("user-module.carousel-title-5")}</a>
            </div>
            <div className="user-module-container__member-connect">{Translation.translate("user-module.already-member?")}&nbsp;
            <a href={AppConfig.mywortWebHost +"/oauth/login?lang=" + Translation.getLanguageName() + "&referrer=" + window.location.pathname} className="u-text-underline">{Translation.translate("user-module.connect")}</a>
            <br /><br /><a href={"/" + Translation.getLanguageName() + "/mywort/faq"} className="u-text-underline">FAQ</a></div>
        </div>
    )
}

class MyWortAccess extends RefluxComponent {

    render = () => (
        <div className="user-module__main">
            <div className="user-module__latest">{Translation.translate("user-module.latest-posts")}</div>
            <div className="user-module__section">
                <UserPostList posts={this.props.posts} totalPostsCount={this.props.totalPostsCount}/>
            </div>
            <div className="user-module__actions">
              <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/post/create"} className="mywort-btn mywort-btn--orange mywort-btn--large user-module__custom_btn">{Translation.translate("user-module.add-post")}</a>
            </div>
            <div className="user-module__double">
                <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/post"}>
                    <div className="pure-u-1 pure-u-lg-12-24 user-module__left u-hover-primary-color">
                        <div className="user-module__icon"><Svg id="fa-file-text" className="user-module__icon__svg"/></div>
                        <div className="user-module__label" dangerouslySetInnerHTML={{__html: Translation.translate("user-module.manage-posts")}}></div>
                    </div>
                </a>
                <a href={"/" + Translation.getLanguageName() + "/mywort/edit#/group"}>
                    <div className="pure-u-1 pure-u-sm-12-24 user-module__right u-hover-primary-color">
                        <div className="user-module__icon"><Svg id="fa-users" className="user-module__icon__svg"/></div>
                        <div className="user-module__label" dangerouslySetInnerHTML={{__html:Translation.translate("user-module.manage-groups")}}></div>
                    </div>
                </a>
            </div>
        </div>
    );
}

export default class UserModule extends RefluxComponent {

    static propTypes = {
        user                : PropTypes.object,
        posts               : PropTypes.array,
        totalPostsCount     : PropTypes.number,
        onAddPost           : PropTypes.func
    };

    static defaultProps = {
        posts: [],
        totalPostsCount: 0
    };

    initialState = () => ({
        loading: true,
        user: undefined,
        posts: []
    });

    constructor() {
        super();
        this.state = this.initialState();
    }

    componentDidMount() {
        this.listenTo(UserStore, this._onStoreChange);
        UserActions.getUser();
    }

    _onStoreChange = (data) => {
        this.setState({
            loading: false,
            user: data.user
        });
        // Get user's posts if user has access to MyWort
        if(this.state.posts.length === 0 && data.user && data.user.myWortAccess) {
            this._loadUserPosts();
        }
    };

    _loadUserPosts = () => {
        UserApi.getUserPosts().then((data) => {
            this.setState({
                posts: data.posts,
                totalPostsCount: data.total
            })
        });
    };

    addPost = () => window.location = "/" + Translation.getLanguageName() + "/mywort/edit#/post";

    renderLoggedUserModule = () => {
        let mainModule;

        if(this.state.user.myWortAccess === true){
            mainModule = ( <MyWortAccess posts={this.state.posts} /> )
        } else if(this.state.user.myWortAccess === false) {
            mainModule = ( <MyWortBlocked user={this.state.user} /> )
        } else {
            mainModule = ( <MyWortRegister user={this.state.user} /> )
        }

        return (
            <div className="user-module">
                <div className="user-module__orange-header"></div>
                <div className="user-module__user-info-header">
                    <UserAvatarPresenter user={this.state.user} className="user-module__avatar" />
                    <div className="user-module__info">
                        <div className="user-module__name"><a className="u-hover-primary-color ellipsis" data-ellipsis-height="25" href={'/' + Translation.getLanguageName() + '/mywort/author/' + this.state.user.id}>{this.state.user.firstName} {this.state.user.lastName}</a></div>
                        <div className="user-module__link"><a href={'/'+Translation.getLanguageName()+'/user-space'} className="u-hover-primary-color">{Translation.translate("user-module.settings-mywort")}</a></div>
                    </div>
                </div>
                { mainModule }
            </div>
        );
    };

    render = () => {
        if(this.state.loading) {
            return (
                <div className="user-module--loader">
                    <img src={loaderMedium} />
                </div>
            );
        }

        if(this.state.user)
            return this.renderLoggedUserModule();
        else
            return <LoginAndRegister user={this.state.user}
                                     posts={this.state.posts}
                                     totalPostsCount={this.state.totalPostsCount}
                                     onAddPost={this.addPost}/>;
    };
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/components/user-module/UserModule.jsx